import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
} from '@ublend-npm/aulaui-next';
import PropTypes from 'prop-types';
import { setAPIBlock } from '@core/api/setBlockApi';
import { getCurrentSpaceId } from '@core/selectors/space';

const mapStateToProps = (state) => ({
  spaceId: getCurrentSpaceId(state),
});

const connector = connect(mapStateToProps);

const ActiveDialogBox = ({
  open,
  handleRegenerateSessionToken,
  handleSessionLogout,
  spaceId,
}) => {
  const [loading, setLoading] = useState({ primary: false, secoundry: false });

  useEffect(() => {
    if (open) {
      setAPIBlock(true);
    } else {
      setAPIBlock(false);
    }
  }, [open]);

  const handleYesClick = async () => {
    setLoading({
      ...loading,
      primary: true,
    });
    setAPIBlock(false);
    await handleRegenerateSessionToken(spaceId);
    setLoading({
      ...loading,
      primary: false,
    });
  };

  const handleNoClick = async () => {
    setLoading({
      ...loading,
      secoundry: true,
    });
    setAPIBlock(false);
    await handleSessionLogout();
    setLoading({
      ...loading,
      secoundry: false,
    });
  };

  const buttonActions = {
    primary: {
      label: 'Yes',
      onClick: handleYesClick,
      loading: loading.primary,
      disabled: loading.secoundry,
    },
    secondary: {
      label: 'No',
      onClick: handleNoClick,
      loading: loading.secoundry,
      disabled: loading.primary,
    },
  };

  const displayContent =
    "Please click 'Yes' to stay signed in. If you select 'No,' you will be logged out.";

  const displayTitle = 'Are you still using Aula?';
  return (
    <Dialog open={open} width="600" height="auto">
      <DialogTitle closeIcon={false}>{displayTitle}</DialogTitle>
      <DialogContent>{displayContent}</DialogContent>
      <DialogActions
        primary={buttonActions.primary}
        secondary={buttonActions.secondary}
        border={false}
      />
    </Dialog>
  );
};

ActiveDialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  spaceId: PropTypes.string.isRequired,
  handleRegenerateSessionToken: PropTypes.func.isRequired,
  handleSessionLogout: PropTypes.func.isRequired,
};

export default connector(ActiveDialogBox);
